<template>
  <div class="hero-text-slider">
    <h1 v-if="heroH1 !== ''" v-html="heroH1"/>
    <h2 v-if="typeof heroH2 !== 'undefined'" v-html="heroH2"/>
    <p v-if="typeof heroP !== 'undefined'" v-html="heroP"/>
    <router-link
      :to="getHeroLink"
      class="glaxi__link">
        {{ heroLinkText }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HeroTextSlider',
  props: {
    heroH1: {
      type: String,
      required: false
    },
    heroH2: {
      type: String,
      required: false
    },
    heroP: {
      type: String,
      required: false
    },
    internalPage: {
      type: Boolean,
      default: false
    },
    heroLink: {
      type: String,
      required: true
    },
    heroLinkText: {
      type: String,
      required: true
    }
  },
  computed: {
    getHeroLink: {
      get () {
        if (this.heroLink.slice(-1) !== '/') return this.heroLink + '/'
        return this.heroLink
      }
    },
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
</style>
  